import { API_CONFIG } from "../utils/apiConfig";

/**
 * Authentication API functions
 * Centralized API calls for auth-related operations
 */

export const authApi = {
  /**
   * Send password reset email
   */
  forgotPassword: async (email) => {
    const response = await fetch(
      `${API_CONFIG.B2B_API_URL}/api/b2b/auth/forgot-password`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to send reset email");
    }

    return data;
  },

  /**
   * Reset password with token
   */
  resetPassword: async (token, newPassword) => {
    const response = await fetch(
      `${API_CONFIG.B2B_API_URL}/api/b2b/auth/reset-password`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
          password: newPassword,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to reset password");
    }

    return data;
  },

  /**
   * Verify email with token
   */
  verifyEmail: async (token) => {
    const response = await fetch(
      `${API_CONFIG.B2B_API_URL}/api/b2b/auth/verify-email/${token}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Email verification failed");
    }

    return data;
  },

  /**
   * Resend verification email
   */
  resendVerification: async (email) => {
    const response = await fetch(
      `${API_CONFIG.B2B_API_URL}/api/b2b/auth/resend-verification`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to resend verification email");
    }

    return data;
  },
};

